var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconBackupCodesmin = function SvgIconBackupCodesmin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 33,
    fill: "#7542E5",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    x: 4,
    y: 5,
    fill: "#fff",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 6,
    x: 2,
    y: 35,
    fill: "#054096",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#054096",
    d: "M15.994 11.228a.69.69 0 0 0-1.023 0l-4.802 5.154a.65.65 0 0 0 0 .874l4.802 5.154a.69.69 0 0 0 1.023 0 .815.815 0 0 0 0-1.098l-4.184-4.496L16 12.32a.814.814 0 0 0-.006-1.092m7.219 0a.69.69 0 0 1 1.023 0l4.802 5.154a.65.65 0 0 1 0 .874l-4.802 5.154a.69.69 0 0 1-1.023 0 .816.816 0 0 1 0-1.098l4.184-4.496-4.19-4.496a.814.814 0 0 1 .006-1.092"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconBackupCodesmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_backup_codes.min.ca03a91267a05f031f63524cfb53b9e5.svg";